var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheetGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5364 7.28471V22.2635C21.5355 22.4943 21.4888 22.7226 21.399 22.9352C21.3092 23.1477 21.1781 23.3404 21.0133 23.5019C20.8485 23.6634 20.6532 23.7906 20.4389 23.8761C20.2246 23.9616 19.9954 24.0037 19.7646 24H4.23523C3.77404 24 3.33163 23.8173 3.00486 23.4918C2.67808 23.1664 2.49357 22.7247 2.4917 22.2635V1.73647C2.49357 1.27528 2.67808 0.83362 3.00486 0.50817C3.33163 0.18272 3.77404 -3.77966e-06 4.23523 0L13.4117 0L21.5364 7.28471Z",
    fill: "#CBCBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5364 7.28471H15.0846C14.6241 7.28471 14.1824 7.10176 13.8567 6.77611C13.5311 6.45045 13.3481 6.00878 13.3481 5.54824V0L21.5364 7.28471Z",
    fill: "#EFEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetGrey);
export default __webpack_public_path__ + "static/media/sheet-grey.7df217f5baaec9ad21a140e5345ff907.svg";
export { ForwardRef as ReactComponent };